export class InvoiceError {
  id?: number;
  version?: number;

  message: string;
  evidence: string;
  invoiceId: number;
  vendorInvoiceId: number;
}